import { WebSignOutService } from '../auth/cognito/service/WebSignOutService';

export const SignoutHandler = (): void => {
  WebSignOutService.signOut().catch(e => console.warn('Running WebSignOutService.signOut failed', e));
};
